module.exports = __webpack_public_path__ + "static/media/propertytwo.26629748.png";